// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../../user/v1/user";
/**
 * @generated from protobuf message c1.api.app.v1.AppOwnerRef
 */
export interface AppOwnerRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppOwnersRequest
 */
export interface SearchAppOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppOwnerRef refs = 4
     */
    refs: AppOwnerRef[];
    /**
     * @generated from protobuf field: repeated string user_ids = 5
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppOwnersResponse
 */
export interface SearchAppOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Search App Owners by a few properties.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppOwnersRequest
 */
export interface ListAppOwnersRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppOwnersResponse
 */
export interface ListAppOwnersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Empty request body. Just placeholder for the add app owner request which uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.AddAppOwnerRequest
 */
export interface AddAppOwnerRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
}
/**
 * Empty response with a status code indicating success
 *
 * @generated from protobuf message c1.api.app.v1.AddAppOwnerResponse
 */
export interface AddAppOwnerResponse {
}
/**
 * RemoveAppOwnerRequest is the request body for removing an app owner. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppOwnerRequest
 */
export interface RemoveAppOwnerRequest {
    /**
     * App ID of the app to remove the owner from.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * User ID of the user to remove as an owner.
     *
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppOwnerResponse
 */
export interface RemoveAppOwnerResponse {
}
/**
 * The request message for setting the app owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppOwnersRequest
 */
export interface SetAppOwnersRequest {
    /**
     * The app_id field for the app to set the owners of.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The user_ids field for the users to set as an owner of the app.
     *
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * The empty response message for setting the app owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppOwnersResponse
 */
export interface SetAppOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppOwnerIDsRequest
 */
export interface ListAppOwnerIDsRequest {
    /**
     * The app_id field for the app to list owners of.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * The response message for listing app owners IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppOwnerIDsResponse
 */
export interface ListAppOwnerIDsResponse {
    /**
     * The list of owner IDs for the app.
     *
     * @generated from protobuf field: repeated string user_ids = 1
     */
    userIds: string[];
}
/**
 * The request message for deleting app owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppOwnersRequest
 */
export interface DeleteAppOwnersRequest {
    /**
     * The app_id field for the app to remove the owner of.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The user_ids field for the users to set as an owner of the app.
     *
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * the empty response message for deleting app owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppOwnersResponse
 */
export interface DeleteAppOwnersResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class AppOwnerRef$Type extends MessageType<AppOwnerRef> {
    constructor() {
        super("c1.api.app.v1.AppOwnerRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppOwnerRef>): AppOwnerRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AppOwnerRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppOwnerRef): AppOwnerRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppOwnerRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppOwnerRef
 */
export const AppOwnerRef = new AppOwnerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppOwnersRequest$Type extends MessageType<SearchAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppOwnerRef },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppOwnersRequest>): SearchAppOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.refs = [];
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppOwnersRequest): SearchAppOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppOwnerRef refs */ 4:
                    message.refs.push(AppOwnerRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string user_ids */ 5:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* repeated c1.api.app.v1.AppOwnerRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            AppOwnerRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 5; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppOwnersRequest
 */
export const SearchAppOwnersRequest = new SearchAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppOwnersResponse$Type extends MessageType<SearchAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppOwnersResponse>): SearchAppOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppOwnersResponse): SearchAppOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppOwnersResponse
 */
export const SearchAppOwnersResponse = new SearchAppOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnersRequest$Type extends MessageType<ListAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppOwnersRequest>): ListAppOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppOwnersRequest): ListAppOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnersRequest
 */
export const ListAppOwnersRequest = new ListAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnersResponse$Type extends MessageType<ListAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppOwnersResponse>): ListAppOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppOwnersResponse): ListAppOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnersResponse
 */
export const ListAppOwnersResponse = new ListAppOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppOwnerRequest$Type extends MessageType<AddAppOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.AddAppOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AddAppOwnerRequest>): AddAppOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AddAppOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAppOwnerRequest): AddAppOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAppOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppOwnerRequest
 */
export const AddAppOwnerRequest = new AddAppOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppOwnerResponse$Type extends MessageType<AddAppOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.AddAppOwnerResponse", []);
    }
    create(value?: PartialMessage<AddAppOwnerResponse>): AddAppOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AddAppOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAppOwnerResponse): AddAppOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAppOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppOwnerResponse
 */
export const AddAppOwnerResponse = new AddAppOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppOwnerRequest$Type extends MessageType<RemoveAppOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAppOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RemoveAppOwnerRequest>): RemoveAppOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RemoveAppOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAppOwnerRequest): RemoveAppOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAppOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppOwnerRequest
 */
export const RemoveAppOwnerRequest = new RemoveAppOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppOwnerResponse$Type extends MessageType<RemoveAppOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAppOwnerResponse", []);
    }
    create(value?: PartialMessage<RemoveAppOwnerResponse>): RemoveAppOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveAppOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAppOwnerResponse): RemoveAppOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAppOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppOwnerResponse
 */
export const RemoveAppOwnerResponse = new RemoveAppOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppOwnersRequest$Type extends MessageType<SetAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App_Owner" } }] } });
    }
    create(value?: PartialMessage<SetAppOwnersRequest>): SetAppOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SetAppOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppOwnersRequest): SetAppOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppOwnersRequest
 */
export const SetAppOwnersRequest = new SetAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppOwnersResponse$Type extends MessageType<SetAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppOwnersResponse", []);
    }
    create(value?: PartialMessage<SetAppOwnersResponse>): SetAppOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAppOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppOwnersResponse): SetAppOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppOwnersResponse
 */
export const SetAppOwnersResponse = new SetAppOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnerIDsRequest$Type extends MessageType<ListAppOwnerIDsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnerIDsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppOwnerIDsRequest>): ListAppOwnerIDsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppOwnerIDsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppOwnerIDsRequest): ListAppOwnerIDsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppOwnerIDsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnerIDsRequest
 */
export const ListAppOwnerIDsRequest = new ListAppOwnerIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppOwnerIDsResponse$Type extends MessageType<ListAppOwnerIDsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppOwnerIDsResponse", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppOwnerIDsResponse>): ListAppOwnerIDsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppOwnerIDsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppOwnerIDsResponse): ListAppOwnerIDsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string user_ids */ 1:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppOwnerIDsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string user_ids = 1; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppOwnerIDsResponse
 */
export const ListAppOwnerIDsResponse = new ListAppOwnerIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppOwnersRequest$Type extends MessageType<DeleteAppOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAppOwnersRequest>): DeleteAppOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteAppOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppOwnersRequest): DeleteAppOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppOwnersRequest
 */
export const DeleteAppOwnersRequest = new DeleteAppOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppOwnersResponse$Type extends MessageType<DeleteAppOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppOwnersResponse", []);
    }
    create(value?: PartialMessage<DeleteAppOwnersResponse>): DeleteAppOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppOwnersResponse): DeleteAppOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppOwnersResponse
 */
export const DeleteAppOwnersResponse = new DeleteAppOwnersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppOwners
 */
export const AppOwners = new ServiceType("c1.api.app.v1.AppOwners", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/owners", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppOwners", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Owner", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppOwnersRequest, O: ListAppOwnersResponse },
    { name: "ListOwnerIDs", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Owner", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Owner" }] } }, I: ListAppOwnerIDsRequest, O: ListAppOwnerIDsResponse },
    { name: "Set", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/apps/{app_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Owner" }], group: "App Owner" }] } }, I: SetAppOwnersRequest, O: SetAppOwnersResponse },
    { name: "Add", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/owners/{user_id}", group: "App Owner" }] } }, I: AddAppOwnerRequest, O: AddAppOwnerResponse },
    { name: "Remove", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/owners/{user_id}", group: "App Owner" }] } }, I: RemoveAppOwnerRequest, O: RemoveAppOwnerResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Owner" }], group: "App Owner" }] } }, I: DeleteAppOwnersRequest, O: DeleteAppOwnersResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppOwnersSearch
 */
export const AppOwnersSearch = new ServiceType("c1.api.app.v1.AppOwnersSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppOwnersRequest, O: SearchAppOwnersResponse }
]);
